import React from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { pagesKey } from '@dashboard/lib/queryKeys';
import usePageQueries from '@dashboard/hooks/queries/usePageQueries';
import Form from './Formik/Form';
import Dialog from './Dialog';

const EditPageNameDialog = ({ isOpen, onClose, checkout }) => {
  const { updatePage } = usePageQueries();
  const queryClient = useQueryClient();
  const dialogCopy = (() => {
    switch (checkout.type) {
      case 'event':
        return {
          title: 'Rename event',
          label: 'Name',
        };
      case 'form':
        return {
          title: 'Rename form',
          label: 'Name',
        };
      case 'checkout':
      default:
        return {
          title: 'Rename checkout page',
          label: 'Name',
        };
    }
  })();

  return (
    <Dialog
      open={isOpen}
      onCancel={onClose}
      title={dialogCopy.title}
      cancelButton={null}
      confirmButton={null}
    >
      <div className="h-full flex-1 flex flex-col mt-2">
        <Form
          showState={false}
          initialValues={{
            name: checkout.name,
          }}
          onSubmit={async (values, actions) => {
            try {
              const response = await updatePage(
                {
                  name: values.name,
                },
                checkout._id,
              );

              onClose();

              actions.resetForm();

              queryClient.invalidateQueries({ queryKey: pagesKey });

              return {
                data: {
                  name: response.data.name,
                },
              };
            } catch (err) {
              return {
                error: err.message,
              };
            }
          }}
          fields={[
            {
              name: 'name',
              label: dialogCopy.label,
              required: true,
              autoComplete: 'off',
              helpText: 'Visible to you only. Not shown to customers.',
            },
          ]}
          submitButton={{
            label: 'Save',
            size: 'full',
          }}
        />
      </div>
    </Dialog>
  );
};

export default EditPageNameDialog;
